<template>
<collapsible v-model="open" :class="`info-spoiler ${open ? 'open' : 'closed'}`">
    <template v-slot:caption>
        <span class="caption">
            <slot name="caption"/>
        </span>
    </template>
    <slot />
</collapsible>
</template>

<script>
import Collapsible from '../Collapsible.vue'

export default {
    name: 'infospoiler',
    components: {  
        Collapsible
    },
    data() {
        return {
            open: false,
        }
    }
}
</script>

<style lang="scss" scoped>

.info-spoiler {
    border-top: none;
    max-width: 44em;

    &.open {
        /deep/ .lbl-toggle {
            border-bottom: none;
        }
    }
}

/deep/ .lbl-toggle {
    &:hover {
        background-color: unset !important;
        color: unset !important;
    }
}

/deep/ .content-inner .ps {
    max-height: 3000px !important;
}

/deep/ .marker {
    font-size: 26px;
    padding: 0 0;
    // transition: transform 0.5s ease-out;
}

/deep/ .caption {
    display: inline-block;
    margin-bottom: 0;
    padding: 0 0;
    transition: transform 0.5s ease-out;
}

.wrap-collapsible {
    border: 2px solid;
    border-image: var(--diia-gradient);
    border-image-slice: 2;
}
</style>